"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintMap = void 0;
var MapLegend_1 = require("../MapLegend");
var PrintMap = /** @class */ (function () {
    function PrintMap(_elementId) {
        var _this = this;
        if (_elementId === void 0) { _elementId = "placeholder-printMap"; }
        this._elementId = _elementId;
        this._initialised = false;
        this.init = function () {
            if (!_this._initialised) {
                _this.isPrintMap = $("body.printMap").length !== 0;
                _this._element = $("#" + _this._elementId);
                if (_this.isPrintMap) {
                    _this.addHandlers();
                    _this.showCornerCoordinates = true;
                    _this.showLegend = true;
                    _this.scaleLine = {
                        units: "metric"
                    };
                    _this.attribution = {
                        collapsible: false,
                        target: document.getElementById("printMapAttributions")
                    };
                    _this.showCornerCoordinates = ($("#printOptions-showCornerCoordinates").val() == 1) ? true : false;
                }
                else {
                    //not a print map so render the button
                    _this.initHtml();
                    _this.addHandlers();
                }
                _this._initialised = true;
            }
        };
        this.initHtml = function () {
            var html = "\n<div id=\"printButtonContainer\" class=\"mb-2\">\n    <button id=\"printButton\"\n            class=\"btn btn-tools\"\n            data-bs-toggle=\"modal\"\n            data-bs-target=\"#printModal\">\n        <i class=\"fas fa-print\"></i>\n        <span>Print map</span>\n    </button>\n</div> ";
            _this._element.append(html);
        };
        this.setMap = function (map) {
            _this._map = map;
            if (_this.showCornerCoordinates) {
                _this.addCornerCoordinates();
            }
            if (_this.showLegend) {
                _this.addLegend();
            }
            //no active panel for print map
            _this._map.mapStore.onActivePanelChanged(null);
        };
        this.addHandlers = function () {
            $("#printMapButton").on("click", function () {
                window.print();
                return false;
            });
        };
        this.addLegend = function () {
            _this.legend = new MapLegend_1.MapLegend("printMap-legend", _this._map, _this._map.mapStore, _this._map.options.layerGroupCollection.vectorLayerGroups);
        };
        this.addCornerCoordinates = function () {
            var self = _this;
            var setCornerCoordinates = function () {
                var extents = self._map.getReprojectedMapExtent(self._map.options.dataProjection);
                $(".printMap-coordinate-minx").text(extents.minx.toFixed(0));
                $(".printMap-coordinate-maxx").text(extents.maxx.toFixed(0));
                $(".printMap-coordinate-miny").text(extents.miny.toFixed(0));
                $(".printMap-coordinate-maxy").text(extents.maxy.toFixed(0));
            };
            _this._map.olMap.on('moveend', function (e) {
                setCornerCoordinates();
            });
            setCornerCoordinates();
        };
        this.init();
    }
    return PrintMap;
}());
exports.PrintMap = PrintMap;
//# sourceMappingURL=PrintMap.js.map